import { Directive, ElementRef, Input, AfterViewInit } from '@angular/core';
import { UtilityService } from './../providers/utility.service';

@Directive({
  selector: '[checkRole]'
})
export class FieldPermissionDirective implements AfterViewInit {
  permissionJson: any;

  @Input('checkRole') checkRole: string;

  constructor(private el: ElementRef, private service: UtilityService) {
  }

  ngAfterViewInit() {
    this.checkPermission(this.checkRole);
  }


  private checkPermission(role: string) {
    if (sessionStorage.getItem('permissions') != null) {
      this.permissionJson = JSON.parse(sessionStorage.getItem('permissions'));
    }
    if (this.service.checkFieldPermission(role, this.permissionJson.perm)) {
      if (this.el.nativeElement.tagName === 'A') {
        this.el.nativeElement.removeAttribute('href');
        this.el.nativeElement.className += ' disable-anchor';
        this.el.nativeElement.parentElement.className += ' disable-cursor';
      }
      this.el.nativeElement.disabled = true;
    }
  }
}
